module.exports = __webpack_public_path__ + "img/your_spanking.17ca7b43.jpg";